// 一键申请项目权限弹窗的筛选与选择计算。
// 这里保持纯函数，方便单测覆盖“查询条件 + 分页批量选择”的边界情况。
import { filterVibeProjects } from './vibeProjectFilter'

const normalizeText = value => String(value ?? '').trim().toLowerCase()

export const BATCH_APPLY_PAGE_SIZE = 10

const getOwnerText = project => (
    project?.ownerUserNick || project?.ownerUserName || project?.ownerUserId || ''
)

// 查询条件覆盖项目名称、项目标识、所有者与项目简介，便于在多页项目里定位。
export function filterBatchApplyProjects(projects, keyword) {
    const list = Array.isArray(projects) ? projects : []
    const normalizedKeyword = normalizeText(keyword)
    if (!normalizedKeyword) return list
    return list.filter(project => [
        project?.projectName,
        project?.projectSlug,
        getOwnerText(project),
        project?.description,
    ].some(field => normalizeText(field).includes(normalizedKeyword)))
}

export function filterBatchApplyProjectsByKind(projects, projectKindFilter) {
    return filterVibeProjects(projects, 'all', projectKindFilter)
}

// 页码越界（筛选后变短）时回落到有效范围。
export function getBatchApplyPage(total, currentPage, pageSize = BATCH_APPLY_PAGE_SIZE) {
    const lastPage = Math.max(1, Math.ceil((Number(total) || 0) / pageSize))
    const page = Math.floor(Number(currentPage) || 1)
    return Math.min(Math.max(page, 1), lastPage)
}
